import React, { useContext, useMemo, useState } from "react";
import { useConverters } from "./../../pm-converters/context";
import { RICOS_LINE_SPACING_TYPE } from "./../../ricos-content";
import { EditorContext, ModalServiceContext, RicosContext } from "./../../ricos-context";
import { StylesContext } from "./../../ricos-styles";
import { useBiNext } from "./../../_shared/bi-context-provider/bi-context-provider";
import { lineSpacingModals } from "./../consts";
import { DropdownModal, ListItemSection, ListItemSelect } from "./../../toolbars-ui";
import { getLineHeightStyleBySelectedNode } from "./../../tiptap-extensions/ricos-styles";
import { CustomSpacingEditorModal } from "../custom-spacing-editor-modal/custom-spacing-editor-modal";
import { MODAL_ROOT, PREDEFINED_SPACING_OPTION, SPACING_SELECTOR_BUTTON } from "../data-hooks";
import { useCurrentSpacing } from "./get-current-selection";
import classes from "./insert-decoration-modal-scss";
const removeDuplicateLineSpacingOptions = (lineSpacingOptions) => {
  return Object.values(
    lineSpacingOptions.reduce((allOptions, option) => {
      allOptions[option.text] = option;
      return allOptions;
    }, {})
  );
};
const InsertDecorationModal = ({ closeModal, referenceElement }) => {
  const { getPublicCommands, adapter } = useContext(EditorContext);
  const { t, isMobile, jsdomMode } = useContext(RicosContext);
  const publicCommands = getPublicCommands();
  const modalService = useContext(ModalServiceContext);
  const logBi = useBiNext({ modalId: lineSpacingModals.spacingOptions, pluginId: "lineSpacing" });
  const lineSpacing = useCurrentSpacing();
  const [initialLineSpacing] = useState(lineSpacing);
  const { styles } = useContext(StylesContext);
  const converters = useConverters();
  const insertDecoration = (data, options2 = {}) => {
    publicCommands.insertDecoration(
      RICOS_LINE_SPACING_TYPE,
      {
        data
      },
      options2
    );
    closeModal();
  };
  const openCustomSpacingEditor = () => {
    modalService.closeModal(lineSpacingModals.spacingOptions);
    modalService.openModal({
      id: lineSpacingModals.customSpacing,
      Component: CustomSpacingEditorModal,
      componentProps: {
        initialLineSpacing,
        insertDecoration
      },
      layout: isMobile ? "fullscreen" : "floating",
      withTransition: !isMobile,
      positioning: {
        referenceElement,
        placement: "bottom"
      },
      enableDrag: !isMobile,
      dragHandleSelector: "[data-drag-handler]",
      onClickOutside: () => {
      },
      disableArrowNavigation: true,
      returnFocusToEditor: true
    });
  };
  const options = useMemo(() => {
    const current = lineSpacing["line-height"];
    const isCurrentInOptions = PREDEFINED_LINE_HEIGHTS.some(
      (lineHeight) => lineHeight.text === current
    );
    if (isCurrentInOptions || current === "") {
      return PREDEFINED_LINE_HEIGHTS;
    }
    const calculatedLineHeight = getLineHeightStyleBySelectedNode({
      tiptapEditor: adapter.tiptapEditor,
      styles,
      pmConverters: converters
    });
    const allSpacingOptions = [
      ...PREDEFINED_LINE_HEIGHTS,
      { text: calculatedLineHeight ?? current, commandKey: current }
    ];
    const lineSpacingOptions = removeDuplicateLineSpacingOptions(allSpacingOptions).sort(
      (a, b) => Number(a.text) - Number(b.text)
    );
    return lineSpacingOptions;
  }, [lineSpacing["line-height"]]);
  return /* @__PURE__ */ React.createElement(
    DropdownModal,
    {
      dataHook: MODAL_ROOT,
      options: [
        ...options.map(({ text, commandKey }) => /* @__PURE__ */ React.createElement(
          ListItemSelect,
          {
            dataHook: PREDEFINED_SPACING_OPTION,
            key: commandKey,
            title: t(text),
            selected: initialLineSpacing["line-height"] === commandKey,
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                insertDecoration({ ...lineSpacing, "line-height": commandKey });
                e.stopPropagation();
                logBi({ dataHook: PREDEFINED_SPACING_OPTION, value: commandKey });
              }
            },
            onClick: () => {
              insertDecoration({ ...lineSpacing, "line-height": commandKey });
              logBi({ dataHook: PREDEFINED_SPACING_OPTION, value: commandKey });
            }
          }
        )),
        /* @__PURE__ */ React.createElement(ListItemSection, { key: "divider", type: "divider" }),
        /* @__PURE__ */ React.createElement(
          ListItemSelect,
          {
            key: "customSpacing",
            dataHook: SPACING_SELECTOR_BUTTON,
            title: t("LineSpacing_customSpacing"),
            onClick: openCustomSpacingEditor,
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                openCustomSpacingEditor();
                e.stopPropagation();
              }
            },
            className: classes.spacingSelector
          }
        )
      ],
      jsdomMode
    }
  );
};
const PREDEFINED_LINE_HEIGHTS = [
  { text: "1", commandKey: "1" },
  { text: "1.5", commandKey: "1.5" },
  { text: "2", commandKey: "2" },
  { text: "2.5", commandKey: "2.5" },
  { text: "3", commandKey: "3" }
];
export {
  InsertDecorationModal
};
//# sourceMappingURL=insert-decoration-modal.js.map
